import { render, staticRenderFns } from "./MaintenanceEmergencyAlert.vue?vue&type=template&id=6b9530d2&scoped=true"
import script from "./MaintenanceEmergencyAlert.vue?vue&type=script&lang=js"
export * from "./MaintenanceEmergencyAlert.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceEmergencyAlert.vue?vue&type=style&index=0&id=6b9530d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9530d2",
  null
  
)

export default component.exports